import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Dialog from '@comp/Dialog/Dialog';
import H3 from '@base/H3/H3';
import P1 from '@base/P1/P1';
import Button from '@base/Button/Button';
import { Fonts, Spacings } from '@styles/index';

const Container = styled.div`
  width: 500px;
  height: 232px;
  box-sizing: border-box;
  padding: ${Spacings.SPACING_6B};
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${Spacings.SPACING_6B};
`;

const TextWrapper = styled.div`
  flex: 1;
  text-align: left;
`;

const Image = styled.img`
  width: 100px;
  height: 100px;
  flex-shrink: 0;
`;

const Message = styled(P1)`
  margin-top: ${Spacings.SPACING_2B};
  color: var(--color-text-secondary);
  font-size: ${Fonts.H5};
  font-weight: ${Fonts.REGULAR};
  line-height: ${Fonts.H3};
`;

const ButtonsWrapper = styled.div`
  margin-top: ${Spacings.SPACING_8B};
`;

interface ViolationTerminatedDialogProps {
  show: boolean;
  onClose: () => void;
}

const ViolationTerminatedDialog = ({
  show,
  onClose
}: ViolationTerminatedDialogProps) => (
  <Dialog
    center
    disableBackdropClick
    dialogState={show}
    onClose={onClose}
    borderRadius="8px"
  >
    <Container>
      <Content>
        <TextWrapper>
          <H3>Exceeded violations</H3>

          <Message>
            You are being removed from the test as you have exceeded the
            permissible violations for this test.
          </Message>
        </TextWrapper>

        <Image src="/svgs/violation-exceeded.svg" alt="Violation exceeded" />
      </Content>

      <ButtonsWrapper>
        <Button
          // @ts-ignore — Button is JS forwardRef without prop types
          grid={12}
          variant="filled"
          label="Okay, got it"
          color="black"
          onClick={onClose}
        />
      </ButtonsWrapper>
    </Container>
  </Dialog>
);

ViolationTerminatedDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ViolationTerminatedDialog;
